export var componentsLocales = {
  removeButtonAriaLabel: 'Remove token'
};